<template>
  <a-result
    status="403"
    title="403"
    sub-title="Você não tem permissão para acessar essa página."
  >
    <template #extra>
      <a-button @click="$router.push('/')">
        Voltar para página inicial
      </a-button>
    </template>
  </a-result>
</template>
